import React from 'react';
import ModalAndroid from 'components/ModalAndroid';
import HashLink from 'components/HashLink';
import Modal from 'components/Modal';
import './style.scss';

export type AppLinkType = 'ios' | 'android' | 'web' | 'mac' | 'win';

interface IAppLinkProps {
    imgSrc?: string; // 图片地址
    type: AppLinkType; // 平台类型
    className?: string;
    url: string; // 跳转链接
}

const AppLink: React.FC<IAppLinkProps> = props => {
    const { imgSrc, type, className, url } = props;

    const handleAndroid = () => {
        Modal.open({
            component: ModalAndroid
        });
    };

    if (type === 'android') {
        return (
            <HashLink onClick={handleAndroid} className={`applink-root ${className}`}>
                <img src={imgSrc} alt={`download ${type} app`} />
            </HashLink>
        );
    }

    return (
        <a href={url} target="view_window" className={`applink-root ${className}`}>
            {!!imgSrc && <img src={imgSrc} alt={`download ${type} app`} />}
        </a>
    );
};

export default AppLink;
